import React, { useRef, useState } from "react";
import { ArrowRightCircleFill } from "react-bootstrap-icons";

const HowItWorks = () => {
  const vidRef = useRef<any>(null);
  const details = [
    {
      title: "How to send money to India from the UK",
      link: "https://www.youtube.com/embed/fPMG9RsRNjM",
    },
    // {
    //   title: "How to send money from Nigeria to other countries",
    //   link: "https://www.youtube.com/embed/XV7VVpZaGC4",
    // },
    {
      title: "How to Send Money to Africa Instantly",
      link: "https://www.youtube.com/embed/RuQosSOUi44",
    },
    {
      title: "How to Apply Discount on the Ileero Remit App",
      link: "https://www.youtube.com/embed/DQURBopscZ8",
    },
    {
      title: "How to Contact Customer Support on Ileero Remit",
      link: "https://www.youtube.com/embed/FFxCceqfVGM",
    },
    {
      title: "Earn passive income as you refer your friends to use Ileero",
      link: "https://www.youtube.com/embed/BcEPbkD3yZI",
    },
  ];
  const [selectedOption, setselectedOption] = useState(details[0]);

  return (
    <div className="bg-secondary" id="how-it-works">
      <div className="how-it-works">
        <div className="text-white container" id="how-it-works">
          <div className="row justify-content-center align-items-center my-5">
            <div className="col-lg-8 text-center">
              <iframe
                width="100%"
                height="100%"
                frameBorder="0"
                src={`${selectedOption.link}?controls=1`}
              ></iframe>
            </div>
            <div className="col-lg-4">
              <h1 className="font-weight-bold">How It Works</h1>
              <div className=" m-0">
                {details.map((detail, index) => (
                  <div
                    key={index}
                    className="cursor-pointer border-bottom border-dark howitworks-btn"
                    onClick={() => setselectedOption(detail)}
                  >
                    <div className="py-3 font-weight-bold m-0 d-flex align-items-center">
                     <div>
                     <ArrowRightCircleFill size={22} className="text-primary mr-2 icon"/></div> <h6 className="m-0">{detail.title}</h6>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
